import { refinersLabel } from 'owa-locstrings/lib/strings/refinerslabel.locstring.json';
import { SelectedCalendars } from './getSearchRefinersButtonText.locstring.json';
import loc, { format } from 'owa-localize';

import isAttachmentsRefinerApplied from './isAttachmentsRefinerApplied';
import isDatesRefinerApplied from './isDatesRefinerApplied';

export default function getSearchRefinersButtonText(): string {
    const searchScopeNameToShow = loc(SelectedCalendars);

    let appliedRefinersCount = 0;
    isAttachmentsRefinerApplied() ? appliedRefinersCount++ : null;
    isDatesRefinerApplied() ? appliedRefinersCount++ : null;

    /**
     * If there aren't any refiners applied, the label will just be the folder
     * name. However, if there are refiners applied, show that count alongside
     * the folder name.
     */
    if (appliedRefinersCount === 0) {
        return searchScopeNameToShow;
    }

    return format(loc(refinersLabel), searchScopeNameToShow, appliedRefinersCount);
}
